<footer>
    <p class="footer-text">&#169; 2023 | All Rights Reserved by LAATAN</p>
</footer>
